import { Modal, ModalOverlay, ModalContent, ModalBody, Button, Box } from '@chakra-ui/react';

export default function BasicModal(props) {
  const { children, isOpen, setIsOpen, size, onClose, setChecked, blockScrollOnMount = true } = props;
  return (
    <>
      <Modal
        isOpen={isOpen}
        size={size ? size : '2xl'}
        blockScrollOnMount={blockScrollOnMount}
        onClose={() => {
          setIsOpen(false);
          setChecked ? setChecked(false) : setIsOpen(false);
          onClose ? onClose('') : setIsOpen(false);
        }}
      >
        <ModalOverlay />
        <ModalContent>
          <Button
            size="sm"
            variant="ghost"
            position="absolute"
            right="12px"
            top="12px"
            onClick={() => setIsOpen(!isOpen)}
            _focus={{ border: 0 }}
            _hover={{ bg: 'gray.100' }}
            fontWeight="normal"
            color="gray.500"
          >
            X
          </Button>
          <ModalBody>
            <Box marginTop="30px">{children}</Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
